// src/components/ConfirmModal/ConfirmModal.tsx
import { FC } from 'react';
import Modal from 'shared/ui/Modal';
import Button, { Button_Style, Button_Type } from 'shared/ui/Button/Button';
import './ConfirmModal.scss';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmType?: Button_Type;
  loading?: boolean;
}

const ConfirmModal: FC<ConfirmModalProps> = ({
                                               isOpen,
                                               onClose,
                                               onConfirm,
                                               title,
                                               message,
                                               confirmLabel = 'Confirmer',
                                               cancelLabel = 'Annuler',
                                               confirmType = Button_Type.PRIMARY,
                                               loading = false
                                             }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="confirm-modal">
        <div className="confirm-message">
          {message.split('\n').map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>

        <div className="confirm-actions">
          <Button
            type={Button_Type.SECONDARY}
            style={Button_Style.OUTLINED}
            label={cancelLabel}
            onClick={onClose}
            disabled={loading}
          />
          <Button
            type={confirmType}
            style={Button_Style.SOLID}
            label={loading ? "..." : confirmLabel}
            onClick={onConfirm}
            disabled={loading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;